import { FlexColumn } from "@/components/Flex";
import HtmlText from "@/components/HtmlText";
import Mountable from "@/components/styled/div/Mountable";
import { themeColors } from "@/utils/themeColors";
import { useRef } from "react";
import { useChatEditorCommunicator } from "../hooks/useChatEditorCommunicator";
import { EditorContextProvider } from "@/components/FullPageEditor/hooks/useEditorContextSelector";
import { getHtmlFromContent } from "@knowt/editor/helpers/getHtmlFromContent";
import ChatEditor from "./ChatEditor";
import { S3UploadJobContextProvider } from "@knowt/syncing/context/S3UploadJobContext";

const ChatInput = ({
    id,
    placeholder,
    disabled,
    disabledReason,
}: {
    id?: string;
    placeholder: string;
    disabled?: boolean;
    disabledReason?: string;
}) => {
    const inputContainerRef = useRef<HTMLDivElement>(null);

    const selectedContent = useChatEditorCommunicator(s => s.selectedContent);
    const inputQuestion = useChatEditorCommunicator(s => s.inputQuestion);

    const preparedSelectedContent = selectedContent?.trim();
    const hasSelectedContent = !!preparedSelectedContent;

    return (
        <EditorContextProvider
            content={getHtmlFromContent({ content: inputQuestion, type: "note" })}
            editable
            allowAutoSave={false}
            disabledCustomPlaceholder
            placeholder={placeholder}>
            <FlexColumn
                ref={inputContainerRef}
                style={{
                    padding: "1rem",
                    backgroundColor: themeColors.background,
                    borderRadius: "2rem",
                    transition: "border-radius 0.2s ease-in-out",
                    margin: "0 2.5rem",
                    overflow: "hidden",
                    flexShrink: 0,
                }}>
                <Mountable mount={hasSelectedContent}>
                    <span
                        style={{
                            borderRadius: "1.4rem",
                            backgroundColor: themeColors.neutralWhite,
                            marginBottom: "1rem",
                            padding: "2rem",
                            overflow: "hidden",
                        }}>
                        <HtmlText
                            className="bodySecondary1"
                            text={preparedSelectedContent}
                            style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                            }}
                        />
                    </span>
                </Mountable>
                <S3UploadJobContextProvider>
                    <ChatEditor
                        id={id}
                        placeholder={placeholder}
                        inputContainerRef={inputContainerRef}
                        disabled={disabled}
                        disabledReason={disabledReason}
                    />
                </S3UploadJobContextProvider>
            </FlexColumn>
        </EditorContextProvider>
    );
};

export default ChatInput;
